store.admin.attributes = {};
store.admin.attributes.init = function() {
	var $attributes = $('#attributes');
	$attributes.find('.sel').each(function(){
		var $c = $(this);
		$c.change(function() {
			var $tr = $c.parents('tr').first();
			var $r = $tr.find('.req');
			if (this.checked) {
				$r.removeAttr('disabled');
			}
			else {
				$r.attr('disabled', 'disabled');
			}
		});
		$c.trigger('change');
	});
	var $table = $attributes.find('table');
	// nestedSortble has a very nice css for .handle
	$table.addClass('nestedSortable');
	$table.find('th').each(function(){
		var $t = $(this);
		// Set width so we dont mess up the column widths when dragging a tr
		$t.css('width', $t.width()+"px");
	});
	var $tbody = $table.find('tbody');
	$tbody.addClass('ui-sortable');
	$tbody.sortable({
		handle: '.handle'
	});
};
